export enum InsurancesSearchTerm {
  Policy = "Póliza",
  Identification = "Identificación",
  ClientName = "Nombre del Cliente",
  Date = "Fecha",
  All = "Varios Criterios",
}
